// Core
import { all, call } from 'redux-saga/effects';

// Instruments
import { authWatchers } from '../bus/auth/saga/watchers';

export function* rootSaga () {
    yield all([call(authWatchers) ]);
}
